import React, { useEffect, useState } from "react";
import Modal from '../../../common/Modal'
import searchIcon from "media/icons/dls/search.svg";
import filterIcon from "media/icons/dls/filter.svg";
import "./AddRCModal.scoped.scss";
import useSelector from "store/useSelector";
import { useDispatch } from "react-redux";
import useDebounce from "utilities/useDebounce";
import { setSearchText } from "store/manageSW/manageSWActions";

import {
  addFilterItem,
  applyFilter,
  clearFilter,
  removeFilterItem,
  setRCType,
  setStringFilter,
} from "store/swList/swListActions";

import FilterModal from "components/common/FilterModal";
import { IMasterDataItem } from "interfaces/masterData/masterDataInterfaces";
import { MetaDataNames } from "store/masterData/masterDataTypes";
import { clearSearchedMasterDataItems } from "store/masterData/masterDataActions";
import RCList from "./RCList";
import RCListTime from "./RCListTime";
import { RCTypes, SWTypes } from "interfaces/sw/SWInterfaces";


interface IAddRCModal {
  onModalClick?(): void,
  header: string,
  onlyTask: boolean,
  AddRCStepsToSw(guid: string, version: number, source: string): void
  AddRCTimeStepsToSw(guid: string, version: number, source: string, rcType: string): void
  stepGuid?: string,
  allowedSourceSystems: string[],
  defaultSourceSystem: string,
  hideSourceSystems: boolean,
  rcTypeButton: RCTypes,
  parentGuid?: string
}

const AddRCModal: React.FC<IAddRCModal> = (props) => {
  const TimeSystem: string = "TIME";
  const WRSystem: string = "WR";
  const [searchTerm, setSearchTerm] = useState("");
  const [isFilterModalOpen, setFilterIsModalOpen] = useState(false);
  const [sourceSystem, setSourceSystem] = useState(props.defaultSourceSystem);
  const [filterStatus, setFilterStatus] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 750);
  const {
    swList: {
      swListData: {
        swList,
        loadOperation,
      },
      filterData,
    },
    manageSW: {
      SW,
      enableConfiguredMFGPlantsInTLMValue,
    },
  } = useSelector(store => store);
  const dispatch = useDispatch();

  useEffect(() => {
    const searchedTypes: SWTypes[] = [];
    const privateSWTypes: SWTypes[] = [];

    if (SW.type === SWTypes.TLMSWI) {
      searchedTypes.push(SWTypes.TLMRC);

      // Passed MFGRC type
      if (
        props.rcTypeButton === RCTypes.Task ||
        props.rcTypeButton === RCTypes.Step ||
        props.rcTypeButton === RCTypes.SubStep
      ) {
        searchedTypes.push(SWTypes.MFGRC);
        privateSWTypes.push(SWTypes.MFGRC);
      }
    }

    if (SW.type === SWTypes.MFGSWI || SW.type === SWTypes.MFGRC) {
      searchedTypes.push(SWTypes.MFGRC);
      searchedTypes.push(SWTypes.TLMRC);
      privateSWTypes.push(SWTypes.TLMRC);

      let owningPlantCode = "";
      if (
        SW !== undefined &&
        SW.owningPlant !== undefined &&
        SW.owningPlant.code !== undefined
      ) {
        owningPlantCode = SW.owningPlant?.code;
      }

      let item2: IMasterDataItem = {
        guid: owningPlantCode,
        code: SW.owningPlant?.code,
        value: "",
      };
      dispatch(
        addFilterItem({
          metaDataName: "currentOwningPlants",
          item: item2,
        })
      );
    }

    if (SW.type === SWTypes.TLMRC) {
      searchedTypes.push(SWTypes.TLMRC);
      searchedTypes.push(SWTypes.MFGRC);
      privateSWTypes.push(SWTypes.MFGRC);
    }

    if (
      (filterStatus || (searchTerm && searchTerm.trim() !== "")) &&
      !enableConfiguredMFGPlantsInTLMValue
    ) {

      dispatch(
        setSearchText({
          searchText: debouncedSearchTerm.trim(),
          onlyTask: props.onlyTask,
          isSourceSystemTIME: sourceSystem === TimeSystem,
          rcTypeButton: props.rcTypeButton,
          searchSource: "AddRCModal" + SW.type,
          parentGuid: props.parentGuid
        })
      );
    } else if (filterStatus || (searchTerm && searchTerm.trim() !== "")) {
      dispatch(
        setSearchText({
          searchText: debouncedSearchTerm.trim(),
          onlyTask: props.onlyTask,
          isSourceSystemTIME: sourceSystem === TimeSystem,
          rcTypeButton: props.rcTypeButton,
          searchSource: "AddRCModal" + SW.type,
          parentGuid: props.parentGuid
        })
      );
    }

    for (let type of searchedTypes) {
      let item: IMasterDataItem = {
        guid: type,
        code: type,
        value: "",
      };
      dispatch(
        addFilterItem({
          metaDataName: "types",
          item,
        })
      );
    }

    for (let type of privateSWTypes) {
      let item: IMasterDataItem = {
        guid: type,
        code: type,
        value: "",
      };
      dispatch(
        addFilterItem({
          metaDataName: "privateSWTypes",
          item,
        })
      );
    }
  }, [
    debouncedSearchTerm,
    dispatch,
    props.onlyTask,
    sourceSystem,
    filterStatus,
    SW.type,
  ]);

  const setIsModelOpenOnClick = () => {
    dispatch(clearFilter());
    setFilterIsModalOpen(true);
    dispatch(clearSearchedMasterDataItems());

    let itemTLMRC: IMasterDataItem = {
      guid: "TLMRC",
      code: "TLMRC",
      value: "",
    };
    let itemMFGRC: IMasterDataItem = {
      guid: "MFGRC",
      code: "MFGRC",
      value: "",
    };

    if (SW.type === SWTypes.TLMSWI || SW.type === SWTypes.TLMRC) {
      dispatch(
        addFilterItem({
          metaDataName: "types",
          item: itemTLMRC
        })
      );
      dispatch(
        addFilterItem({
          metaDataName: "types",
          item: itemMFGRC
        })
      );
    }
    else {
      dispatch(
        addFilterItem({
          metaDataName: "types",
          item: itemMFGRC
        })
      );
      dispatch(
        addFilterItem({
          metaDataName: "types",
          item: itemTLMRC
        })
      );
    }
  }

  const checkFilter = () => {
    if (filterData.filterFields.typesFilter.length !== 0
      || filterData.filterFields.owningOrgsFilter.length !== 0
      || filterData.filterFields.productCentersFilter.length !== 0
      || filterData.filterFields.epicEquipmentFilter.length !== 0
      || filterData.filterFields.hazardCategoriesFilter.length !== 0
      || filterData.filterFields.owningPlantsFilter.length !== 0
      || filterData.filterFields.performingOrgsFilter.length !== 0
      || filterData.filterFields.materialsFilter.length !== 0
      || filterData.filterFields.workCentersFilter.length !== 0) {
      return true;
    }
    return false;
  }

  const applyDipatchFilter = () => {
    if (checkFilter()) {
      setFilterStatus(true);
      if (!enableConfiguredMFGPlantsInTLMValue) {
        dispatch(applyFilter({
          isRCFilter: true, onlyTask: props.onlyTask, isSourceSystemTIME: false,
          rcTypeButton: props.rcTypeButton,
          searchSource: "AddRCModal" + SW.type
        }));
      }
      else {
        dispatch(applyFilter({
          isRCFilter: true, onlyTask: props.onlyTask, isSourceSystemTIME: false,
          rcTypeButton: props.rcTypeButton,
          searchSource: "AddRCModal" + SW.type
        }));
      }
      dispatch(clearSearchedMasterDataItems());
    }
  }

  const onRemoveFilter = (item: IMasterDataItem, name: MetaDataNames) => {
    if (name === "types" && (item.guid === SWTypes.TLMRC || item.guid === SWTypes.MFGRC)) {
      dispatch(clearFilter());
    } else {
      dispatch(
        removeFilterItem({
          metaDataName: name,
          item,
        })
      );
    }
  }

  return (
    <Modal
      header={props.header}
      width="70%"
      top="50%"
      controls={(
        <>
          <button
            className="primary-button ok-button"
            onClick={props.onModalClick}
          >
            Close
          </button>
        </>
      )}
      isOpen={true}
    >
      <div className="input-holder">
        {!props.hideSourceSystems && props.allowedSourceSystems.map(currentSourceSystem =>
          <span key={currentSourceSystem}>
            <input type="radio"
              name="SourceSystem"
              value={currentSourceSystem}
              checked={currentSourceSystem === sourceSystem}
              onChange={e => setSourceSystem(currentSourceSystem)} />
            {currentSourceSystem}
          </span>
        )}
        <input
          type="text"
          className="searchBar"
          id="sw-search"
          placeholder={"Begin typing to search..."}
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          disabled={loadOperation?.isWorking}
        />
        <img
          src={searchIcon}
          alt="Search"
          title="Search"
          className="icon-small search-button"
        />
        {sourceSystem === WRSystem &&
          <img
            src={filterIcon}
            onClick={setIsModelOpenOnClick}
            alt="Filters"
            className="icon-small filter-button"
            title="Filters"
          />
        }
      </div>
      {(filterStatus || (debouncedSearchTerm
        && debouncedSearchTerm.trim() !== ""))
        && swList
        && swList.length > 0
        && sourceSystem === WRSystem &&
        <RCList swList={swList} AddRCStepsToSw={props.AddRCStepsToSw}  ></RCList>
      }
      {debouncedSearchTerm
        && debouncedSearchTerm.trim() !== ""
        && swList
        && swList.length > 0
        && sourceSystem === TimeSystem &&
        <RCListTime swList={swList} AddRCTimeStepsToSw={props.AddRCTimeStepsToSw} rcTypeButton={props.rcTypeButton}  ></RCListTime>
      }
      {swList.length <= 0 &&
        <h2>No Reusable Content found.</h2>}
      {isFilterModalOpen &&
        <FilterModal
          currentSWFilterValues={filterData.filterFields}
          onAddItem={(item: IMasterDataItem, name: MetaDataNames) => dispatch(
            addFilterItem({
              metaDataName: name,
              item,
            })
          )}
          onRemoveItem={(item: IMasterDataItem, name: MetaDataNames) => onRemoveFilter(item, name)}
          applyFilter={applyDipatchFilter}
          clearFilter={() => {
            setFilterStatus(false);
            dispatch(clearFilter());
          }}
          setSWStringFilter={(name: "maintenanceTaskIds", value: string) => dispatch(
            setStringFilter({
              attributeName: name,
              value: value,
            })
          )}
          setIsModalOpen={setFilterIsModalOpen}
          showStatusFilter={true}
          isRCFilters={true}
          setRCType={(value) => dispatch(setRCType(value))}
          rcTypeButton={props.rcTypeButton}
        />
      }
    </Modal>
  );
};

export default AddRCModal;